import React, { useEffect, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { trackEvent, AnalyticsEvents } from '../../utils/analytics';

const CookieBanner: React.FC = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setOpen(true);
    }
  }, []);

  const handleChoice = (choice: 'accepted' | 'declined') => {
    localStorage.setItem('cookieConsent', choice);
    trackEvent(AnalyticsEvents.CookieConsent, { choice });
    setOpen(false);
  };

  if (!open) return null;

  return (
    <Box sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, bgcolor: 'background.paper', p: 2, boxShadow: 3, zIndex: 2500 }}>
      <Typography variant="body2" sx={{ mb: 1 }}>
        We use essential cookies to make Enantio work and optional analytics to improve the service.
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
        <Button size="small" onClick={() => handleChoice('declined')}>Decline</Button>
        <Button size="small" variant="contained" onClick={() => handleChoice('accepted')}>Accept</Button>
      </Box>
    </Box>
  );
};

export default CookieBanner;
